import TechnicalDocument from './TechnicalDocument';
export default TechnicalDocument;
